import { useMutation } from '@tanstack/react-query';

import type {
  ServiceCategoryFormData,
  ServiceCategoryFormResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useDeleteServiceCategoryMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; id: number }) =>
      HttpClient.request({
        method: 'DELETE',
        url: `${params.url}/${params.id}`,
      }),
  });

export const useServiceCategoryFormMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      method: 'POST' | 'PUT';
      data: ServiceCategoryFormData;
    }) =>
      HttpClient.request<ServiceCategoryFormResponse>({
        method: params.method,
        url: params.url,
        data: params.data,
      }),
  });
